"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeSurveyAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const __1 = require("../..");
const closeSurveyAction = (survey, title) => {
    const type = (0, CardHelper_1.getSurveyTypeDisplay)(survey.type);
    const closeCard = __1.CardHelper.newCard();
    closeCard.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Are you sure you want to close this ${type}?`,
        wrap: true,
        color: adaptivecards_1.TextColor.Attention,
    }));
    closeCard.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "Close now",
        style: "destructive",
        data: (0, __1.SurveyCloseCommand)(survey.id).toTaskFetchCommand(),
    }));
    return __1.CardHelper.create(adaptivecards_1.ShowCardAction, {
        title: title || `Close ${type}`,
        style: "positive",
        card: closeCard,
    });
};
exports.closeSurveyAction = closeSurveyAction;
//# sourceMappingURL=CloseSurveyAction.js.map